<template>
    <div class="row justify-content-center">
        <b-modal
            ref="new-calculations-request-modal"
            v-model="showModal"
            :hide-header-close="true"
            :hide-footer="true"
            title="Calculation Request Debug Info"
            scrollable
            centered
            size="xl"
            justify="center"
            persistent
            @hide="hideModal"
        >
            <b-card>
                <b-card-body class="request-details-content">
                    <div
                        v-for="[key, value] of jsonData"
                        :key="key"
                        class="pt-4"
                    >
                        <div class="accordion" role="tablist">
                            <b-card no-body class="mb-1">
                                <b-card-header
                                    header-tag="header"
                                    class="p-1"
                                    role="tab"
                                >
                                    <b-button
                                        v-b-toggle="`accordion-${key}`"
                                        block
                                        variant="info"
                                    >
                                        {{ Object.keys(value)[0] }}
                                    </b-button>
                                </b-card-header>
                                <b-collapse
                                    :id="`accordion-${key}`"
                                    visible
                                    accordion="my-accordion"
                                    role="tabpanel"
                                >
                                    <b-card-body>
                                        <b-card-text>
                                            <pre>
                                                {{ value }}
                                            </pre>
                                        </b-card-text>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>
                        </div>
                    </div>
                    <br />
                    currentPublisher : {{ calculationRequest.currentPublisher }}
                </b-card-body>
            </b-card>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        calculationRequestDebugInfo: {
            type: Object,
            default: () => ({})
        },
        showModal: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            calculationRequest: {},
            jsonData: [],
            openModal: false
        };
    },

    mounted() {
        if (!this.calculationRequestDebugInfo) {
            return;
        }

        this.calculationRequest = this.calculationRequestDebugInfo;

        let entries = Object.entries(this.calculationRequest.allQueueJobsData);

        this.jsonData = entries;
    },

    methods: {
        hideModal() {
            this.calculationRequestDebugInfo = {};

            this.$emit('hide');
        }
    }
};
</script>
